import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './Component/content/content.component';
import { HomeComponent } from './Component/home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { IsalreadyloginGuard } from './guards/isalreadylogin.guard';
import { BrowserModule  } from '@angular/platform-browser';
import { FormsModule  } from '@angular/forms';
import { AppComponent } from './app.component';
import { StreamComponent } from './Component/stream/stream.component';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { BlogsComponent } from './Component/blogs/blogs.component';
import { NewsComponent } from './Component/news/news.component';
import { BestplayerComponent } from './Component/bestplayer/bestplayer.component';
import { TournamentsComponent } from './Component/tournaments/tournaments.component';
import { NewplayersComponent } from './Component/newplayers/newplayers.component';
import { ToolsComponent } from './Component/tools/tools.component';
import { AboutusComponent } from './Component/aboutus/aboutus.component';
import { ProamateurtournamentComponent } from './Component/proamateurtournament/proamateurtournament.component';
import { RegularstreamComponent } from './Component/regularstream/regularstream.component';
import { AxieleagueComponent } from './Component/axieleague/axieleague.component';
import { SponsorComponent } from './Component/sponsor/sponsor.component';
import { RankingComponent } from './component/ranking/ranking.component';
import { ScheduleComponent } from './component/schedule/schedule.component';
import { StatisticsComponent } from './component/statistics/statistics.component';



const appRoutes: Routes = [ 
  { path: '', component: HomeComponent, pathMatch: 'full'},
  { path: 'home', component: HomeComponent},    
  { path: 'aboutus', component: AboutusComponent}, 
  { path: 'streams', component: StreamComponent}, 
  { path: 'blogs', component: BlogsComponent}, 
  { path: 'news', component: NewsComponent  },
  { path: 'bestplayer', component: BestplayerComponent  },
  { path: 'tournaments', component: TournamentsComponent  },
  { path: 'newplayers', component: NewplayersComponent  },
  { path: 'tools', component: ToolsComponent  },
  { path:'axieleague', component: AxieleagueComponent },
  { path:'regularstreams',component: RegularstreamComponent },
  { path:'proamateurtournament',component: ProamateurtournamentComponent },
  { path:'sponsors',component: SponsorComponent },
  { path:'ranking',component: RankingComponent },
  { path:'schedule',component: ScheduleComponent },
  { path:'statistics',component: StatisticsComponent },
  { path:'**',component:HomeComponent},
   
  

];
@NgModule({
  

  imports: [BrowserModule,
    FormsModule,RouterModule.forRoot(appRoutes,{ useHash: true })],

   exports: [RouterModule],
 })
export class AppRoutingModule { }
export const routingComponents = [
  ContentComponent,
  HomeComponent,
  StreamComponent,
  BlogsComponent,
  NewsComponent,
  BestplayerComponent,
  TournamentsComponent,
  NewplayersComponent,
  ToolsComponent,
  ProamateurtournamentComponent,
  RegularstreamComponent,
  AxieleagueComponent,
  RankingComponent,
  ScheduleComponent,
  StatisticsComponent
]